import { get } from 'lodash';
import SHOW_INSURANCE_NETWORKS from '../queries/insurance/show-insurance-networks';

function fetchInsuranceNetworks(sortingParams, client) {
  return client.query({
    query: SHOW_INSURANCE_NETWORKS,
    fetchPolicy: 'network-only',
    variables: { sortingParams }
  }).then(response => get(response, 'data.insuranceNetworks'));
}

export default fetchInsuranceNetworks;
